import { type ReactNode, useEffect, useRef } from "react";

const PORTAL_TITLE = "Linear Portal";

const updateDocumentTitle = (main: HTMLElement, titleCount?: number): void => {
  const heading = main.querySelector("h1")?.textContent?.replace(/\s+/g, " ").trim();
  const title = heading ? `${heading} · ${PORTAL_TITLE}` : PORTAL_TITLE;
  document.title = titleCount && titleCount > 0 ? `(${titleCount}) ${title}` : title;
};

export const RouteContent = ({ pathname, titleCount, children }: { pathname: string; titleCount?: number; children: ReactNode }) => {
  const mainRef = useRef<HTMLElement>(null);
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    const main = mainRef.current;
    if (!main) return;
    updateDocumentTitle(main, titleCount);
    const observer = new MutationObserver(() => updateDocumentTitle(main, titleCount));
    observer.observe(main, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [titleCount]);

  useEffect(() => {
    const main = mainRef.current;
    if (!main) return;
    updateDocumentTitle(main, titleCount);
    if (previousPathnameRef.current !== pathname) main.focus();
    previousPathnameRef.current = pathname;
  }, [pathname, titleCount]);

  return (
    <main id="main-content" ref={mainRef} tabIndex={-1}>
      {children}
    </main>
  );
};
